module.exports = __webpack_public_path__ + "img/1.9090f5d.png";